import axios from "axios";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import Swal from "sweetalert2";

const ChangePasswordModal = (props) => {
  const { userId, setModalShow } = props;
  const [Data, setData] = useState({
    password: "",
    reenterPassword: "",
  });
  const [newPasswordShown, setNewPasswordShown] = useState(false);
  const [repeatPasswordShown, setRepeatPasswordShown] = useState(false);
  const toggleNewPasswordShown = () => {
    setNewPasswordShown(!newPasswordShown);
  };
  const toggleRepeatPasswordShown = () => {
    setRepeatPasswordShown(!repeatPasswordShown);
  };
  const { password, reenterPassword } = Data;

  const onInputChange = (e) => {
    setData({ ...Data, [e.target.name]: e.target.value });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (password === reenterPassword) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change the password?",
        //icon: "warning",
        dangerMode: true,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put(`user/` + userId, Data, { withCredentials: true }).then(() => {
            setModalShow(false);
            Swal.fire({
              title: "Done!",
              text: "Password has been changed successfully",
              icon: "success",
              timer: 2000,
              button: false,
            });
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          setModalShow(false);
          setData({ password: "", reenterPassword: "" });
        }
      });
    } else {
      await Swal.fire({
        title: "",
        text: "Both Passwords Are Not Matching",
        icon: "error",
        timer: 2000,
        confirmButtonText: "OK",
      });
    }
  };
  return (
    <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body>
        <h5 className="text-center">Change Password</h5>
        <form onSubmit={submitHandler}>
          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className="input-group">
                <input
                  type={newPasswordShown ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={onInputChange}
                  className="form-control"
                  id="password"
                  minLength="6"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  required
                />
                <span className="input-group-text" id="basic-addon1">
                  {newPasswordShown ? (
                    <BsEyeSlash onClick={() => toggleNewPasswordShown()} />
                  ) : (
                    <BsEye onClick={() => toggleNewPasswordShown()} />
                  )}
                </span>
              </div>
            </div>
            <div className="col-md-6">
              <label htmlFor="reenterPassword" className="form-label">
                Reenter Password
              </label>
              <div className="input-group">
                <input
                  type={repeatPasswordShown ? "text" : "password"}
                  name="reenterPassword"
                  value={reenterPassword}
                  minLength="6"
                  onChange={onInputChange}
                  className="form-control"
                  id="reenterPassword"
                  placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                  required
                />
                <span className="input-group-text" id="basic-addon1">
                  {repeatPasswordShown ? (
                    <BsEyeSlash onClick={() => toggleRepeatPasswordShown()} />
                  ) : (
                    <BsEye onClick={() => toggleRepeatPasswordShown()} />
                  )}
                </span>
              </div>
            </div>
          </div>
          <div className="float-end">
            <button
              type="submit"
              className="btn btn-success me-2"
              disabled={!password || !reenterPassword || password !== reenterPassword}
            >
              Change
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ChangePasswordModal;

ChangePasswordModal.propTypes = {
  userId: PropTypes.string.isRequired,
  setModalShow: PropTypes.func.isRequired,
};
